module.exports = __webpack_public_path__ + "img/cladify_logo_white_white_sm.b16ba818.png";